var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Copyright"},[_c('span',[_vm._v("技术支持： "),_c('a',{attrs:{"href":"https://www.tyxwl.com/"}},[_vm._v("贵州天逸轩网络科技有限公司")])])])}]

export { render, staticRenderFns }